import { createContext, useContext } from 'react';

type CompanyParams = {
  companyId: number;
};

export const CompanyContext = createContext<CompanyParams | null>(null);

export const useGetProductCompany = () => {
  return useContext(CompanyContext);
};
